'use client';
import React from 'react';
import Link from 'next/link';
import * as Styled from './styled';
import Tag from '@/ui/Tag';
import { TNavOption } from '../../RepositoryNavTabs';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { DoubleArrowRightIcon } from '@radix-ui/react-icons';

const DropdownNav: React.FC<{ options: TNavOption[] }> = ({ options }) => {
  return (
    <Styled.DropdownMenuStyle>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <button className="IconButton" aria-label="More options">
            <DoubleArrowRightIcon />
          </button>
        </DropdownMenu.Trigger>

        <DropdownMenu.Portal>
          <Styled.DropdownMenuContent className="DropdownMenuContent" sideOffset={5}>
            {options.map((option) => (
              <Link href={option.path} key={option.name}>
                <Styled.DropdownMenuItem>
                  {option.icon}
                  {option.label}
                  {!!option.count && (
                    <Tag pill small>
                      {option.count}
                    </Tag>
                  )}
                </Styled.DropdownMenuItem>
              </Link>
            ))}
            <Styled.DropdownMenuArrow />
          </Styled.DropdownMenuContent>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </Styled.DropdownMenuStyle>
  );
};

export default DropdownNav;
